var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "creatEditor" },
    [
      _c("Header", { staticStyle: { height: "40px" }, attrs: { notOut: "" } }),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "el-icon-arrow-left goback", on: { click: _vm.goback } },
        [_vm._v("返回")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "creatEditor_bg"
        },
        [
          _c(
            "el-form",
            {
              ref: "formInline",
              staticClass: "creatEditor_opt",
              attrs: {
                rules: _vm.rules,
                inline: true,
                model: _vm.formInline,
                size: "mini"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "标题", prop: "imageTextName" } },
                [
                  _c("el-input", {
                    attrs: { size: "mini", placeholder: "请输入内容" },
                    model: {
                      value: _vm.formInline.imageTextName,
                      callback: function($$v) {
                        _vm.$set(_vm.formInline, "imageTextName", $$v)
                      },
                      expression: "formInline.imageTextName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.resourcesFrom === "1"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "分类", prop: "categoryId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "mini",
                            clearable: "",
                            placeholder: "请选择"
                          },
                          model: {
                            value: _vm.formInline.categoryId,
                            callback: function($$v) {
                              _vm.$set(_vm.formInline, "categoryId", $$v)
                            },
                            expression: "formInline.categoryId"
                          }
                        },
                        _vm._l(_vm.categoryList, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.categoryName, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.productFlag == 1 && _vm.courseModel == 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: " 科目:", prop: "subjectId" } },
                    [
                      _c(
                        "el-select",
                        {
                          on: { change: _vm.subjectChange },
                          model: {
                            value: _vm.formInline.subjectId,
                            callback: function($$v) {
                              _vm.$set(_vm.formInline, "subjectId", $$v)
                            },
                            expression: "formInline.subjectId"
                          }
                        },
                        _vm._l(_vm.subjectList, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.courseModel != 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "资源库分类", prop: "materialId" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          size: "mini",
                          placeholder: "全部",
                          options: _vm.cascaderOptions,
                          props: {
                            emitPath: false,
                            label: "name",
                            value: "id"
                          },
                          filterable: "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.formInline.materialId,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "materialId", $$v)
                          },
                          expression: "formInline.materialId"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("add-mixed-mode", {
            style: { height: "calc(100% - " + _vm.formHeight + "px)" },
            attrs: {
              subjectId: _vm.formInline.subjectId,
              courseId: _vm.courseId,
              questionId: _vm.questionId
            },
            on: { questionIdChange: _vm.questionIdChange },
            model: {
              value: _vm.imageText,
              callback: function($$v) {
                _vm.imageText = $$v
              },
              expression: "imageText"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "creatEditor_footer" }, [
        _c(
          "span",
          { staticClass: "foldedList", on: { click: _vm.foldedList } },
          [_vm._v("一键收起")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "zl_button zl_blueButton",
            on: {
              click: function($event) {
                return _vm.handleSaveText("formInline")
              }
            }
          },
          [_vm._v("保 存")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-071e9a4f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-071e9a4f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/new_course_editor/creatEditor.vue
// module id = null
// module chunks = 